import React from 'react';
import { injectIntl } from '../../util/reactIntl';
import css from './ChangeLanguageForm.module.css';
import { useDispatch } from 'react-redux';
import { updateProfileLanguage } from '../../ducks/user.duck';
import { TbWorld } from 'react-icons/tb';
import MenuLabel from '../MenuLabel/MenuLabel';
import MenuContent from '../MenuContent/MenuContent';
import MenuItem from '../MenuItem/MenuItem';
import Menu from '../Menu/Menu';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { IoIosCheckmark } from 'react-icons/io';
import { normalizeLocale } from '../../util/locales';

// import { Helmet } from 'react-helmet';
const ChangeLanguageFormComponent = props => {
  const { intl } = props;
  const value = normalizeLocale(intl.locale);
  const dispatch = useDispatch();

  const handleOnChange = async event => {
    const selectedOption = event.currentTarget.getAttribute('language');
    await dispatch(updateProfileLanguage(selectedOption));
    window.location.reload(true);
  };
  const englishLanguage = intl.formatMessage({
    id: 'ChangeLanguageForm.englishLanguage',
  });
  const greekLanguage = intl.formatMessage({
    id: 'ChangeLanguageForm.greekLanguage',
  });
  const languageOptions = (
    <Menu>
      <MenuLabel className={css.profileMenuLabel} isOpenClassName={css.profileMenuIsOpen}>
        <div className={css.changeLanguageForm}>
          <TbWorld className={css.worldIcon} />
          <div className={css.selectedLabel}>{{ 'en-US': 'EN', el: 'EL', es: 'ES' }[value]}</div>
          <MdKeyboardArrowDown />
        </div>
      </MenuLabel>
      <MenuContent className={css.profileMenuContent}>
        <MenuItem key="">
          <div className={css.option} language="en-US" onClick={e => handleOnChange(e)}>
            <div className={css.label}>{englishLanguage}</div>
            {value === 'en-US' ? <IoIosCheckmark className={css.checkMark} /> : null}
          </div>
        </MenuItem>
        <MenuItem key="hhhh">
          <div className={css.option} language="el" onClick={e => handleOnChange(e)}>
            <div className={css.label}>{greekLanguage}</div>
            {value === 'el' ? <IoIosCheckmark className={css.checkMark} /> : null}
          </div>
        </MenuItem>
        <MenuItem key="es">
          <div className={css.optionSecond} language="es" onClick={handleOnChange}>
            <div className={css.label}>
              {intl.formatMessage({ id: 'ChangeLanguageForm.spanishLanguage' })}
            </div>
            {value === 'es' ? <IoIosCheckmark className={css.checkMark} /> : null}
          </div>
        </MenuItem>
      </MenuContent>
    </Menu>
  );
  return <div className={css.changeFormContainer}>{languageOptions}</div>;
};

const ChangeLanguageForm = injectIntl(ChangeLanguageFormComponent);

export default ChangeLanguageForm;
